export interface EventArgument {
  id: string
  name: string
  description: string
  eventAsset: string
  link?: string
  buttonText: string
  type?: string
  buttonColorHex?: string
  active?: boolean
  challengeID?: string
  createdAt: Date
}

export default class AppEvent {
  readonly id: string
  readonly name: string
  readonly description: string
  readonly eventAsset: string
  readonly link?: string
  readonly buttonText: string
  readonly type?: string
  readonly buttonColorHex?: string
  readonly active?: boolean
  readonly challengeID?: string
  readonly createdAt: Date

  constructor(arg: EventArgument) {
    this.id = arg.id
    this.name = arg.name
    this.description = arg.description
    this.eventAsset = arg.eventAsset
    this.link = arg.link
    this.buttonText = arg.buttonText
    this.type = arg.type
    this.buttonColorHex = arg.buttonColorHex
    this.active = arg.active
    this.challengeID = arg.challengeID
    this.createdAt = new Date(arg.createdAt)
  }

  static fromPG(data: any): AppEvent {
    return new AppEvent({
      id: data.id,
      name: data.name,
      description: data.description,
      eventAsset: data.event_asset,
      link: data.link,
      buttonText: data.button_text,
      type: data.type,
      buttonColorHex: data.button_color_hex,
      active: data.active,
      challengeID: data.challenge_id ?? undefined,
      createdAt: data.created_at,
    })
  }
}

